<template>
    <div class="share-link">
        <sheet :show.sync="show">
            <div class="share-link-title">
                <template v-if="title">{{title}}</template>
                <template v-else>{{$t('text.share')}} {{text || $t('text.product')}} {{$t('text.info_to')}}</template>
            </div>
            <sd-button class="share-link-button" @click.native="copyLink()">
                <img src="@/assets/img/link.png" />
                {{$t('text.copy_link')}}
            </sd-button>
        </sheet>
    </div>
</template>

<script>
import sheet from "./sheet.vue";
import sdButton from "./button.vue";

export default {
    name: "sd-share",
    components: { sheet, sdButton },
    props: {
        text: String,
        title: String,
        src: String,
        onBeforeCopy: Function,
    },
    data() {
        return {
            show: true
        }
    },
    watch: {
        show(val) {
            if(!val) {
                this.close();
            }
        }
    },
    methods: {
        copyLink() {
            console.log(this.src)
            this.$utils.copy(this, this.src, this.onBeforeCopy);
            this.$emit("success");
        },

        close() {
            this.$emit("close");
        }
    }
}
</script>

<style lang="scss" scoped>
.share-link {
    /deep/ {
        .project-sheet .sheet-content{
            padding: 16px 20px 32px;

            .share-link-title {
                font-size: 16px;
                font-weight: bold;
                line-height: 20px;
                margin-bottom: 20px;
            }

            .share-link-button {
                height: 52px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 6px;
                }
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/common/share.vue